<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-th-large"></i><span>Versión</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('modelo_version.crear')">
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i>Agregar</button>
                            </template>
                            <!-- <template v-if="AsignarRolPermisosByUsuario.includes('clasificacion.reporte')">
                                <button type="button" class="btn btn-primary"><i class="far fa-file-pdf"></i> Reporte</button>
                            </template> -->
                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->

                            <div class="form-group row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="LeadName">Modelo</label>
                                    <input type="text"  v-on:keyup.enter="listVersion(1,pag_mostrar)" class="form-control" v-model="filtros.modelo"  placeholder="Buscar...">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="LeadName">Versión</label>
                                    <input type="text"  v-on:keyup.enter="listVersion(1,pag_mostrar)" class="form-control" v-model="filtros.version"  placeholder="Buscar...">
                                </div>
                            </div>


                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="LeadName">Registros a mostrar</label>
                                    <input type="number"  v-on:keyup.enter="listVersion(1,pag_mostrar)"  class="form-control" v-model="pag_mostrar">
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="LeadName">Buscar</label>
                                    <button type="button" @click="listVersion(1,pag_mostrar)" class="btn btn-primary form-control"><i class="fas fa-search"></i></button>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="LeadName">Limpiar</label>
                                    <button type="button" @click="limpiarFiltro()" class="btn btn-primary form-control"><i class="far fa-trash-alt"></i></button>
                                </div>
                            </div>
                        </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Acciones</b></th>
                                            <th><b>Modelo</b></th>
                                            <th><b>Version</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="list_modelo_anio.length">
                                        <tr v-for="(c, index) in list_modelo_anio" :key="index">

                                            <td>
                                                <div class="btn-group mb-2 mr-2">
                                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                    <div class="dropdown-menu">
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('modelo_version.editar')">
                                                            <button class="dropdown-item" @click="setObtenerModeloAnio(c)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                        </template>
                                                        <template >
                                                            <button class="dropdown-item"  @click="setDeleteVersion(c.id)"><i class="fa fa-trash text-danger" ></i> Eliminar</button>
                                                        </template>

                                                    </div>
                                                </div>
                                            </td>
                                            <td v-text="c.modelo"></td>
                                            <td v-text="c.version"></td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="3" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Evidencia-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal"></h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form>
                           <div class="row">
                                <div class="col-md-12">
                                     <div class="form-group">
                                        <label>Modelo</label>
                                        <v-select
                                            v-model="data_version.nombre"
                                            @search="selectVehiculo"
                                            label="nombre"
                                            :options="arrayVehiculo"
                                            placeholder="Buscar Vehiculo..."
                                             @input="getDatosVehiculo"
                                        >
                                        <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                        </v-select>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label >Versión</label>
                                        <input type="text" class="form-control" id="name" v-model="data_version.version" placeholder="Ingresar una vesion">
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" v-if="actu_reg==0" class="btn btn-sm btn-primary" @click="setRegistrarVersion" v-text="nameButon">Guardar</button>
                            <button type="button" v-if="actu_reg==1" class="btn btn-sm btn-primary" @click="setActualizarVersion" v-text="nameButon">Actualizar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Evidencia-------------------------------------------------------------->

    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
export default {
    props: ['ruta'],
    data() {
        return {
            filtros:{
                modelo              : '',
                version                : '',
            },
            list_modelo_anio: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,

            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            data_version:{
                id              : 0,
                modelo_id       : '',
                version            : '',
                nombre  : ''
            },
            arrayVehiculo   : [],
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '$ ',
                suffix: '',
                precision: 2,
                masked: false
            },

        }
    },
    mixins: [alertasM],
    computed: {

            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
    methods: {


        async listVersion(page, pag_mostrar){

            try{
                var url = '/version/list';
                this.openCargando();
                let get = {
                    'page'          : page,
                    'pag_mostrar'   : pag_mostrar,
                    'filtro'        : JSON.stringify(this.filtros),
                };
                let response            = await axios.get(url,{params:get});
                var respuesta           = response.data;
                this.pagination         = respuesta.pagination;
                this.list_modelo_anio   = respuesta.versiones;
                this.openCargando(true);

            } catch (err) {
                console.error(err);
                this.openCargando(true);
                 if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
            }

        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.listVersion(page,me.pag_mostrar);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                this.tituloModal = "Registrar Versión";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }else{
               // this.aTipoDocumento = [];
                this.cleanVariables();
            }
        },

        cleanVariables(){
            this.data_version = {
                id              : 0,
                modelo_id       : '',
                version            : '',
            };
        },

        setRegistrarVersion(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/version/registrar';


            axios.post(url, {
                'modelo_id'     : this.data_version.modelo_id,
                'version'          : this.data_version.version,
            }).then(res => {

                this.cleanVariables();//Limpiamos el form
                this.listVersion(1,this.pag_mostrar);
                this.modalShow=false;

                if(res.data.status){

                    this.notify(" Versión registrada con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                console.error(err);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
               for(var key in err.response.data.errors){
                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
               }
              if(err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
            })
        },

        setActualizarVersion(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/version/actualizar';

            axios.put(url, {
                'id'            : this.data_version.id,
                'modelo_id'     : this.data_version.modelo_id,
                'version'          : this.data_version.version,
            }).then(res => {


                this.cleanVariables();//Limpiamos el form
                //this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.listVersion(1,this.pag_mostrar);
                this.modalShow=false;
                if(res.data.status){

                    this.notify(" Versión actualizada con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
                console.error(err);
            })
        },

        async setObtenerModeloAnio(data){

            this.tituloModal = "Actualizar Versión";
            this.nameButon = "Actualizar"
            this.data_version   = {
                id              : data.id,
                modelo_id       : data.idmodelo,
                version         : data.version,
                nombre         : data.modelo,
            };
            this.modalShow = true;
            this.actu_reg = 1;
        },

        setDeleteVersion(id){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar la Version?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){
                        var url = '/version/delete';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                        })
                        .then(res => {


                             this.openCargando(true);

                            if(res.data.status){
                                this.notify(" Version Eliminada con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                            }else{
                                this.notify(" La Version no se puede eliminar por que está en uso","","top","center","fas fa-exclamation-triangle","warning",' flipInX','flipOutX')
                            }
                            this.listVersion(1,this.pag_mostrar);
                        })
                        .catch(err => {
                             this.openCargando(true);
                            if (err.response.status == 401) {
                                if (localStorage['authUser']) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                }
                            }
                            console.error(err);
                        })
                }
            })
        },

        limpiarFiltro(){
            this.filtros = {
                modelo              : '',
                version                : '',
            };
        },

        async selectVehiculo(search, loading ,defecto){

            try{
                let me = this;
                var url=  '/cotizacion/getlistvehiculo';

                let get = {
                    'filtro'        : search,
                };
                let response        = await axios.get(url,{params: get});
                var respuesta       = response.data;
                me.arrayVehiculo    = respuesta;

                if(defecto==null){
                    q                   : search
                    loading(false)
                }

            }catch(err){
                console.error(err);
                if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       }
                }
            }

        },


        getDatosVehiculo(val1){
             let me = this;

            if(val1 ==null){
                me.data_version.modelo_id = 0;
                me.data_version.nombre = "";
            }else{

                me.loading = true;
                me.data_version.modelo_id   = val1.id;
                me.data_version.nombre      = val1.nombre;
            }
        },




    },
    mounted() {
        this.listVersion(1,this.pag_mostrar);
    },
}
</script>

<style>
</style>
